import React from 'react';
import { Section, SectionHeader, replaceStr } from 'flos-react-cvi';

export const ReceiptContainer = ({ resources, customerEmail }) => (
    <Section variant="alt" bordered={true}>
        <div className="container u-Space-up">
            <SectionHeader>{resources['receipt.container.title']}</SectionHeader>
            <ul className="u-Space-up--lg u-Space-down--lg">
                <li className="u-Space-down">{resources['receipt.container.listItem.1']}</li>
                <li className="u-Space-down">{resources['receipt.container.listItem.2']}</li>
                <li className="u-Space-down">
                    {replaceStr(resources['receipt.container.listItem.3'], { '{email}': customerEmail })}
                </li>
            </ul>
            <br />
        </div>
    </Section>
);
